module.exports = __webpack_public_path__ + "static/media/logo.50c550b4.svg";